<script>
	import Tour from "./Tour.svelte";
	import Modal from 'svelte-simple-modal';
</script>

<!-- /*____________ Markup ____________*/ -->
<main>
	<Modal><Tour/></Modal>
</main>

<!-- /*____________ CSS ____________*/ -->
<style>
	main {
		padding: 0;
		margin: 0;
		width: 100%;
		height: 100%;
	}

	:global(html,body){
		overflow: hidden;
		width: 100%;
		height: 100%;
		margin: 0;
	}

	:global(.no-select) {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>